import {
  CUSTOMER_INFO_RECEIVED,
  CUSTOMER_PAYMENT_METHODS_RECEIVED,
  CUSTOMER_INFO_BY_ID_RECEIVED,
} from "../constants/types/acumaticaType";

const initialState = {
  customerInfo: null,
  paymentMethods: [],
  customerByIdInfo: {
    contacts: [],
    isTaxExempt: false,
  },
};

export const acumaticaReducer = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMER_INFO_RECEIVED:
      return {
        ...state,
        customerInfo: action.payload,
      };
    case CUSTOMER_INFO_BY_ID_RECEIVED:
      return {
        ...state,
        customerByIdInfo: action.payload,
      };
    case CUSTOMER_PAYMENT_METHODS_RECEIVED:
      return {
        ...state,
        paymentMethods: action.payload,
      };
    default:
      return state;
  }
};
